import styled from "styled-components";
import media from '~/utils/media';

export const Container = styled.div`
  max-width: 546px;
  max-height: 600px;
  height: 60%;
  width: 68%;
  padding: 32px;
  background-color: white;
  z-index: 11;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SearchArea = styled.button`
  display: block;
  margin: 0 auto;
  color: #222222;
  font-size: 14px;
  font-weight: 700;
  width: 25%;
  height: 10%;
  min-height: 30px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border: 1px solid #DFDFDF;
  border-radius: 2px;
  outline: none;
  appearance: none;
  ${media.pcLarge`
    font-size: 14px;
  `}

  ${media.tabletLarge`
    font-size: 13px;
  `}

  ${media.tabletSmall`
    font-size: 13px;
  `}

  ${media.mobileLarge`
    font-size: 12px;
  `}

  ${media.mobileMid`
    font-size: 10px;
  `}

  ${media.mobileSmall`
    font-size: 10px;
  `}

  &::-ms-expand {
   display: none;
  }
  &::-ms-value {
   background: none;
   color: rgb(76, 76, 76);
  }
  &:disabled {
   color: rgb(174, 174, 174);
   border-color:  rgb(231, 231, 231);
   background-color: rgb(250, 250, 250);
  }
  width:${({ width }) => `${width}`};
`